import {Injectable, Injector} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import {ComponentPortal} from '@angular/cdk/portal';
import {UploadProgressPopupComponent} from './upload-progress-popup.component';

@Injectable({
  providedIn: 'root',
})
export class UploadProgressService {
  private progressSource = new BehaviorSubject<number>(0);
  progress$ = this.progressSource.asObservable();

  private filenameSource = new BehaviorSubject<string>('');
  filename$ = this.filenameSource.asObservable();

  private overlayRef: OverlayRef | null = null;

  constructor(private overlay: Overlay, private injector: Injector) {}

  startUpload(filename: string): void {
    this.filenameSource.next(filename);
    if (!this.overlayRef) {
      this.createPopup();
    }
  }

  updateProgress(progress: number): void {
    if (!this.overlayRef) {
      this.createPopup();
    }
    this.progressSource.next(progress);

    if (progress >= 100) {
      setTimeout(() => this.closePopup(), 5000);
    }
  }

  private createPopup(): void {
    const overlayConfig = {
      hasBackdrop: false,
      positionStrategy: this.overlay.position().global().top('16px').right('16px'),
    };

    this.overlayRef = this.overlay.create(overlayConfig);
    const portal = new ComponentPortal(UploadProgressPopupComponent, null, this.injector);
    this.overlayRef.attach(portal);
  }

  closePopup(): void {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }
}
